'use client';

import { Box, Grid, Typography } from '@mui/material';
import { AiLearnListRow } from '@repo-ui/components/AiLearnListRow';
import { routerPushI18n } from '@repo-ui/router';
import { toast } from 'react-toastify';

// 모델 학습 과정 배우기
const DATA1 = {
  'text-classify': {
    title: '텍스트 분류',
    desc: (
      <>
        회귀 분석(regression analysis)은 관찰된 연속형 변수들에 대해 두 변수 사이의 모형을 구한 뒤
        적합도를 측정해 내는 분석 방법입니다.
      </>
    ),
    href: '/ai/text-classify',
    imgUrl: '/_static/images/dataScience_table.png',
  },
  'image-classify': {
    title: '이미지 분류',
    desc: (
      <>
        회귀 분석(regression analysis)은 관찰된 연속형 변수들에 대해 두 변수 사이의 모형을 구한 뒤
        적합도를 측정해 내는 분석 방법입니다.
      </>
    ),
    href: '/ai/image-classify',
    imgUrl: '/_static/images/dataScience_regress_1.png',
  },
};

// 학습된 모델의 응용 예제
const DATA2 = {
  'face-avatar': {
    title: '얼굴 아바타',
    desc: (
      <>
        회귀 분석(regression analysis)은 관찰된 연속형 변수들에 대해 두 변수 사이의 모형을 구한 뒤
        적합도를 측정해 내는 분석 방법입니다.
      </>
    ),
    href: '/ai/face-avatar',
    imgUrl: '/_static/images/dataScience_regress_1.png',
  },
  'face-landmark': {
    title: '얼굴 랜드마크',
    desc: (
      <>
        회귀 분석(regression analysis)은 관찰된 연속형 변수들에 대해 두 변수 사이의 모형을 구한 뒤
        적합도를 측정해 내는 분석 방법입니다.
      </>
    ),
    href: '/ai/face-landmark',
    imgUrl: '/_static/images/dataScience_regress_3.png',
  },
  'face-detect': {
    title: '얼굴 인식',
    desc: (
      <>
        회귀 분석(regression analysis)은 관찰된 연속형 변수들에 대해 두 변수 사이의 모형을 구한 뒤
        적합도를 측정해 내는 분석 방법입니다.
      </>
    ),
    href: '/ai/face-detect',
    imgUrl: '/_static/images/dataScience_regress_2.png',
  },
  'object-detect': {
    title: '객체 인식',
    desc: (
      <>
        회귀 분석(regression analysis)은 관찰된 연속형 변수들에 대해 두 변수 사이의 모형을 구한 뒤
        적합도를 측정해 내는 분석 방법입니다.
      </>
    ),
    href: '/ai/object-detect',
    imgUrl: '/_static/images/dataScience_table.png',
  },
  'hand-landmark': {
    title: '손 랜드마크',
    desc: (
      <>
        회귀 분석(regression analysis)은 관찰된 연속형 변수들에 대해 두 변수 사이의 모형을 구한 뒤
        적합도를 측정해 내는 분석 방법입니다.
      </>
    ),
    href: '/ai/hand-landmark',
    imgUrl: '/_static/images/dataScience_regress_1.png',
  },
  'pose-landmark': {
    title: '자세 랜드마크',
    desc: (
      <>
        회귀 분석(regression analysis)은 관찰된 연속형 변수들에 대해 두 변수 사이의 모형을 구한 뒤
        적합도를 측정해 내는 분석 방법입니다.
      </>
    ),
    href: '/ai/pose-landmark',
    imgUrl: '/_static/images/dataScience_regress_2.png',
  },
  'lang-detect': {
    title: '언어 감지',
    desc: (
      <>
        회귀 분석(regression analysis)은 관찰된 연속형 변수들에 대해 두 변수 사이의 모형을 구한 뒤
        적합도를 측정해 내는 분석 방법입니다.
      </>
    ),
    href: '/ai/lang-detect',
    imgUrl: '/_static/images/dataScience_regress_3.png',
  },
};

interface Props {}

export function SupervisedList(props: Props) {
  return (
    <Box className="SupervisedList-root">
      <Typography variant="h6" mb={2}>
        모델 만들기
      </Typography>

      <Grid container rowSpacing={4} columnSpacing={3}>
        {Object.entries(DATA1).map(([key, item], idx) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={key}>
            <AiLearnListRow
              title={item.title}
              desc={item.desc}
              imgUrl={item.imgUrl}
              onClick={() => {
                if (item.href) {
                  routerPushI18n(item.href);
                  return;
                }
                toast.warn('지원 예정');
              }}
            />
          </Grid>
        ))}
      </Grid>

      <Typography variant="h6" mt={6} mb={2}>
        모델 응용 예제
      </Typography>
      <Grid container rowSpacing={4} columnSpacing={3}>
        {Object.entries(DATA2).map(([key, item], idx) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={key}>
            <AiLearnListRow
              title={item.title}
              desc={item.desc}
              imgUrl={item.imgUrl}
              onClick={() => {
                if (item.href) {
                  routerPushI18n(item.href);
                  return;
                }
                toast.warn('지원 예정');
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
